export const RegionalPresidentSidebarData = [
    {
        title: 'Dashboard',
        path: '/admin/dashboard',
    },
    {
        title: 'Applications',
        subNav: [
            {
                title: 'New Applications',
                path: '/new_applications',
            },
            {
                title: 'Regional Approvals',
                path: '/regional_approvals',
            },
            {
                title: 'Regional Report',
                path: '/regional_reports',
            },
        ]
    },
    {
        title: 'Membership',
        subNav: [
            {
                title: 'Regional Membership',
                path: '/regional_members',
            },
            {
                title: 'Active Members',
                path: '/active_regional_members',
            },
            {
                title: 'Inactive Members',
                path: '/inactive_regional_members',
            },
        ]
    },

    {
        title: 'Members Accounts',
        path: '/#',
        subNav: [
            {
                title: 'Payment Transactions',
                path: '/regional_payment_transactions',
            },
            {
                title: 'Ledger Accounts',
                path: '/regional_ledger_accounts',
            },
        ]
    },
    {
        title: 'Log Out',
        path: '/admin_logout',
    },

];

